// extracted by extract-css-chunks-webpack-plugin
module.exports = {"table":"table___3G6Z1","row":"row___2IjUQ","label":"label___2Ld3K","amount":"amount___3YCnS","shortTop":"shortTop___7JqFI","total-row":"total-row___2F4Ym"};